module.exports = __webpack_public_path__ + "img/selected_radar_ok.0cbca638.svg";